import g from "./utils/globals";
import Logger from "./utils/Logger";

const logger = new Logger(__filename);

const proxy = {
  fns: [],
  // .on(eventType[, selector], handler[, useCapture])
  on(...args) {
    let idx;
    let handler = args[(idx = 1)];
    if (typeof handler !== "function") {
      handler = args[(idx = 2)];
    }
    args[idx] = this.proxy("event", handler);
  },
  proxy(name, fn, disposable = true) {
    const { request } = g;
    const proxied = (...args) => {
      if (args[0] === "dispose") {
        g.request = false;
      }
      if (request === g.request) {
        Reflect.apply(fn, this, args);
      } else {
        if (!disposable) {
          logger.error(`canceling callback (request-${request} [${name}])`);
        }
        fn = null;
      }
    };
    if (disposable) {
      this.fns.push(proxied);
    }
    return proxied;
  },
  dispose() {
    const length = this.fns.length;
    if (length <= 0) {
      return;
    }
    logger.log(`removing proxied functions (total: ${length})`);
    const result = [];
    this.fns.pop();
    for (const fn of this.fns) {
      result.push(fn("dispose"));
    }
  },
};

export default proxy;
